module.exports = __webpack_public_path__ + "static/media/statistics@2x.bd36be7f.png";